import api from '@/api'
export default {
    namespaced: true,
    state: {
        total:0,
        goodstemplatearr:[],
        editdata:{},
        title:''
    },
    getters: {
    },
    mutations: {
        //存储用户信息
        SET_GOODSTEMPLATELIST: (state, obj) => {

            state.total = obj.total
            state.goodstemplatearr=[...obj.data]
        },
        SET_EDITDATA: (state, obj) => {

            state.editdata={...obj}
        },
        SET_TITLE: (state, title) => {

            state.title=title
        },
        DEL_DATA: (state, index) => {
            state.goodstemplatearr.splice(index,1)
        },
        CLEAR_GOODSTEMPLATELIST: (state) => {

            state.total = 0
            state.goodstemplatearr=[]

        },


    },
    actions: {
        async getGoodstemplatelist({ commit },params={page:1}) {
            
            let {code,message,data}=await api.getgoodstemplatelist(params)
            if (code == 200) {
                commit('SET_GOODSTEMPLATELIST', data);
                return data;
            } else {
                return Promise.reject(new Error(message));
            }
        },
    },
}